/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type Notifications_viewer = {
    readonly regInfo?: ReadonlyArray<{
        readonly countryCode: string | null;
    } | null> | null | undefined;
    readonly isAutomatedOfferNotificationDisabled: boolean | null;
    readonly conversations?: {
        readonly " $fragmentRefs": FragmentRefs<"Conversations_conversations">;
    } | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ActivityFeed_viewer">;
    readonly " $refType": "Notifications_viewer";
};
export type Notifications_viewer$data = Notifications_viewer;
export type Notifications_viewer$key = {
    readonly " $data"?: Notifications_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "fetchNotifications"
        },
        {
            "defaultValue": 5,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "hasSessionCountryCode"
        },
        {
            "kind": "RootArgument",
            "name": "isClient"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Notifications_viewer",
    "selections": [
        {
            "alias": "isAutomatedOfferNotificationDisabled",
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": "disableAutomatedOfferBellNotification"
                }
            ],
            "kind": "ScalarField",
            "name": "isEnabled",
            "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
        },
        {
            "condition": "hasSessionCountryCode",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "alias": "regInfo",
                    "args": null,
                    "concreteType": "RegionalInfo",
                    "kind": "LinkedField",
                    "name": "regionalInfo",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "countryCode",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        {
            "condition": "fetchNotifications",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": "showUnreadOnly"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        },
                        {
                            "kind": "Literal",
                            "name": "notifications",
                            "value": true
                        }
                    ],
                    "concreteType": "ConversationConnection",
                    "kind": "LinkedField",
                    "name": "conversations",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "Conversations_conversations"
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "Defer",
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ActivityFeed_viewer"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '102e0b6aebf0d06727525570febf66ff';
export default node;
